module.exports = __webpack_public_path__ + "static/media/career-hero-mobile.00beb8dc.mp4";